var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.wireframes),function(ref,i){
var name = ref[0];
var wireframe = ref[1];
return _c('v-col',{key:i,attrs:{"cols":"12","md":"6","lg":"4"}},[_c('router-link',{staticClass:"text--primary text-decoration-none",attrs:{"to":{
        name: 'Wireframes',
        params: { wireframe: wireframe }
      },"rel":"nofollow noopener","target":"_blank"}},[_c('app-figure',{attrs:{"alt":(name + " layout"),"aspect-ratio":16/9,"name":name,"src":("https://cdn.vuetifyjs.com/docs/images/wireframes/" + wireframe + ".svg"),"outlined":""}})],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }